/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './related-data-location.component.html';

@Component({
  standalone: false,
  selector: 'adn-related-data-location',
  template
})
export class RelatedDataLocationComponent {
  @Input() allStats: any;
  @Input() countType: any;
  @Input() relatedChartData: any;
  @Input() changeHook: any;
  @Input() chartType: string;
  @Input() locationsEmpty = false;
  @Input() isPending = false;
}
